import { c as _c } from "react/compiler-runtime";
import ErrorIcon from "@mui/icons-material/Error";
import { ModalRed } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal-red-alert";
export const ModalRedAlert = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-danger3 p-4 mb-4 rounded"><div className="flex items-start"><ErrorIcon sx={{
          color: "#EE4540",
          marginRight: "12px",
          marginTop: "2px",
          fontSize: "24px"
        }} /><ModalRed /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};